import RoomAllotmentFilterModal from './RoomAllotmentFilterModal';

export default RoomAllotmentFilterModal;
